/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Author_PlaceholderInputs */

const en_admin_posts_author_placeholder = /** @type {(inputs: Admin_Posts_Author_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author name`)
};

const zh_admin_posts_author_placeholder = /** @type {(inputs: Admin_Posts_Author_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作者名称`)
};

/**
* | output |
* | --- |
* | "Author name" |
*
* @param {Admin_Posts_Author_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_author_placeholder = /** @type {((inputs?: Admin_Posts_Author_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Author_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_author_placeholder(inputs)
	return zh_admin_posts_author_placeholder(inputs)
});
export { admin_posts_author_placeholder as "admin.posts.author_placeholder" }